import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isLightOnlyPath, setLightOnlyRoute } from './themeStore';

/**
 * Mount once inside the router. Tells the theme store whether the current route is light-only (the admin console), so
 * the page is light there whatever the person chose and their choice comes back when they leave. Renders nothing.
 */
export default function ThemeRouteGuard() {
  const { pathname } = useLocation();
  useLayoutEffect(() => { setLightOnlyRoute(isLightOnlyPath(pathname)); }, [pathname]);
  return null;
}
